<!--使用xgplayer的单个视频播放组件-->

<template>
  <div style="width: 100%; height: 100%">
    <div :id="videoPlayer.videoId" class="xg-video-play"></div>
    <canvas :id="videoPlayer.canvasId" style="display: none" width="515" height="300"></canvas>
  </div>
</template>
<script>
// 导入xgplayer核心和flv插件
import Player from 'xgplayer';
import FlvPlugin from 'xgplayer-flv';
import settings from "@/settings";

// 注册flv插件
Player.use(FlvPlugin);

export default {
  name: "XgVideoPlay",
  props: ["videoPlayer"],
  data() {
    return {
      isMuted: true,
      xgPlayer: null,
      reconnectTimeout: null,
      loaded: !1,
      opened: !1,
      videoElement: null,
      playing: !1,
      deviceNo: "",
      ctx: null,
      canvas: null,
      mediaRecorder: undefined,
      recordedChunks: [],
    };
  },
  mounted() {
    // 初始化配置
  },
  methods: {
    muted() {
      //禁音
      this.isMuted = true;
      if (this.xgPlayer) {
        this.xgPlayer.muted = true;
      }
    },
    voice() {
      //开启声音
      this.isMuted = false;
      if (this.xgPlayer) {
        this.xgPlayer.muted = false;
      }
    },

    load(t) {
      var e = this.videoPlayer.src;
      console.log("load video:" + e);
      var s = e.split('/')
      var d = s[s.length - 1];
      var ss = d.split('-')
      this.deviceNo = ss[0]
      
      // 获取容器元素
      var container = document.getElementById(this.videoPlayer.videoId);
      this.canvas = document.querySelector("#" + this.videoPlayer.canvasId);
      this.ctx = this.canvas.getContext("2d");
      
      // 创建xgplayer实例
      this.xgPlayer = new Player({
        el: container,
        url: e,
        isLive: true,
        autoplay: true,
        muted: this.isMuted,
        fluid: true,
        playbackRate: [0.5, 1, 1.5, 2],
        pip: true,
        volume: 0.6,
        // 媒体类型
        videoType: 'flv',
        // flv插件配置
        flv: {
          cors: true,
          // 视频流中禁用音频解码，避免音频编解码兼容性问题导致视频无法播放
          // 音频通过独立的 AudioPlay 组件（音频专用 FLV 流）播放
          hasAudio: false,
          hasVideo: true,
          stashInitialSize: 128 * 1024, // 初始缓存大小
          enableStashBuffer: true
        },
        // 样式配置
        cssFullscreen: true,
        lang: 'zh-cn',
        // 事件监听
        events: {
          ready: () => {
            console.log('xgplayer ready');
            this.opened = true;
            this.playing = true;
            this.loaded = true;
            this.videoPlayer.onLoaded();
          },
          play: () => {
            console.log('xgplayer play');
            this.playing = true;
          },
          pause: () => {
            console.log('xgplayer pause');
            this.playing = false;
          },
          ended: () => {
            console.log('xgplayer ended');
            this._onPlayComplete();
          },
          error: (err) => {
            console.log('xgplayer error:', err);
            this._onError(err);
          },
          stats: (stats) => {
            // console.log('xgplayer stats:', stats);
            var currentPath = this.deviceNo;
            const startTime = settings.routeStartTime[currentPath]
            if (startTime) {
              // 计算耗时
              console.log(Date.now());
              const renderTime = Date.now() - startTime
              console.log(`终端 ${currentPath} 渲染耗时：${renderTime}`)
              
              // 清除已计算的开始时间，避免重复计算
              delete settings.routeStartTime[currentPath]
            }
          }
        }
      });
      
      // 设置定时器检查连接状态
      setTimeout(this._checkOpenStatus, 5e3);
    },
    unload() {
      this.loaded = !1;

      if (this.xgPlayer) {
        try {
          this.xgPlayer.pause();
        } catch (e) {
          console.warn("XgVideoPlay: pause error", e);
        }
        this.playing = !1;
      }
    },
    getMediaInfo() {
      return this.xgPlayer ? {
        width: this.xgPlayer.videoWidth,
        height: this.xgPlayer.videoHeight
      } : null;
    },
    destroy() {
      console.log("destroy xgplayer");
      if (this.xgPlayer) {
        try {
          this.unload();
        } catch (e) {
          console.warn("XgVideoPlay: unload in destroy error", e);
        }
        try {
          this.xgPlayer.destroy();
        } catch (e) {
          console.warn("XgVideoPlay: xgPlayer destroy error", e);
        }
        this.xgPlayer = null;
        this.videoElement = null;
      }
    },
    _destroy() {
      console.log("_destroy xgplayer");
      this.videoPlayer.VideoPlay
        ? this.videoPlayer.VideoPlay.destroy()
        : this.destroy();
    },
    getCurrentTime() {
      return this.xgPlayer && !0 === this.loaded
        ? this.xgPlayer.currentTime
        : 0;
    },
    setCurrentTime(t) {
      this.xgPlayer && !0 === this.loaded && (this.xgPlayer.currentTime = t);
    },
    getBuffered() {
      return this.xgPlayer && this.loaded ? this.xgPlayer.buffered : null;
    },
    getPlaybackRate() {
      return this.xgPlayer ? this.xgPlayer.playbackRate : 1;
    },
    setVolume(volume) {
      if (this.xgPlayer) {
        this.xgPlayer.volume = Math.max(0, Math.min(1, volume));
      }
    },
    setPlaybackRate(t) {
      this.xgPlayer && (this.xgPlayer.playbackRate = t);
    },
    getPaused() {
      return !!this.xgPlayer && this.xgPlayer.paused;
    },
    pause() {
      this.xgPlayer && this.xgPlayer.pause();
    },
    play() {
      this.xgPlayer && this.xgPlayer.play();
    },
    isPlaying() {
      return this.playing;
    },
    setDebugMode(t) {
      console.log("xgplayer setDebugMode: ".concat(t));
      // xgplayer的调试模式设置
    },
    startRecord() {
      var mediaInfo = this.getMediaInfo();
      if (mediaInfo && mediaInfo.width && mediaInfo.height) {
        this.canvas.width = mediaInfo.width;
        this.canvas.height = mediaInfo.height;
      }
      //定时把video中的内容复制到canvas中
      this.drawFrame(); // 开始绘制

      const canvasStream = this.canvas.captureStream(30); // 25fps

      // 创建音频上下文
      const audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      // 创建媒体源节点
      const mediaSource = audioContext.createMediaElementSource(
        this.xgPlayer.video
      );
      // 创建音频流目的地
      const destination = audioContext.createMediaStreamDestination();
      // 将媒体源连接到目的地
      mediaSource.connect(destination);
      // 获取音频流
      const audioStream = destination.stream;

      // 合并音视频流
      const combinedStream = new MediaStream([
        ...canvasStream.getTracks(),
        ...audioStream.getTracks(),
      ]);

      this.mediaRecorder = new MediaRecorder(combinedStream);

      this.mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          this.recordedChunks.push(event.data);
        }
      };

      this.mediaRecorder.onstop = () => {
        const blob = new Blob(this.recordedChunks, { type: "video/webm" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "recorded_video.webm";
        link.click();
        this.recordedChunks = [];
      };

      this.mediaRecorder.start();
    },
    drawFrame() {
      if (this.ctx && this.xgPlayer && this.xgPlayer.video) {
        this.ctx.drawImage(
          this.xgPlayer.video,
          0,
          0,
          this.canvas.width,
          this.canvas.height
        );
        // 循环调用drawFrame函数，实现视频的连续播放
        requestAnimationFrame(this.drawFrame);
      }
    },
    stopRecord() {
      if (this.mediaRecorder && this.mediaRecorder.state === "recording") {
        this.mediaRecorder.stop();
      }
    },
    send(t) {
      // xgplayer的send方法，用于发送命令
      console.log('send command:', t);
    },
    _checkOpenStatus() {
      try {
       if (
          (this.opened && this.playing) ||
          2 != this.videoPlayer.videoStatus
        ) {
          console.log("check open status： failed， need reconnect");
          this._reconnect();
        }
      } catch (t) { }
    },
    _onMetaDataArrived(t) {
      this.videoPlayer.setPromptWord("empty");
      this.playing = true;
    },
    _onOpen() {
      console.log("_onOpen");
      this.opened = true;
      this.videoPlayer.onLoaded();
    },
    _onReceiveMsg(t) {
      console.log("receiveMsg:".concat(t));
      this.videoPlayer.onReceiveMsg(t);
    },
    _onError(err) {
      console.log("xgplayer error:", err);
      this.videoPlayer.flow = "";
      var i = this.videoPlayer.videoStatus;
      1 == i || 2 == i
        ? ((this.videoPlayer.totalTimeStamp = this.videoPlayer.historyTime),
          this.unload(),
          this.reconnectTimeout && clearTimeout(this.reconnectTimeout),
          (this.reconnectTimeout = setTimeout(this._reconnect, 3e3)))
        : setTimeout(this._destroy, 0);
    },
    _onPlayComplete(t) {
      console.log("videoplay event: LoadingCompleted"),
        (this.videoPlayer.flow = "");
      var e = this.videoPlayer.videoStatus;
      1 == e || 2 == e
        ? (this.unload(),
          this.reconnectTimeout && clearTimeout(this.reconnectTimeout),
          (this.reconnectTimeout = setTimeout(this._reconnect, 3e3)))
        : setTimeout(this._destroy, 0);
    },
    _onStatisticsInfo(t) {
      this.videoPlayer.onStatisticsInfo(t);
    },
    _reconnect() {
      console.log("_reconnect");
      this._destroy();
      this.videoPlayer.reconnect();
      this.reconnectTimeout = null;
    },
  },
};
</script>

<style scoped>
.xg-video-play {
  width: 100%;
  height: 100%;
}
</style>